import React, { Component, ReactNode } from "react";
import { AppError } from "../utils/errorHandler";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: AppError;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error: error instanceof AppError ? error : new AppError(error.message),
    };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error("Error caught by boundary:", error);
    console.error("Error info:", errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-neutral-50">
          <div className="max-w-md p-6 text-center">
            <h1 className="mb-4 text-2xl font-bold text-neutral-900">
              Algo deu errado
            </h1>
            <p className="mb-6 text-neutral-600">
              {this.state.error?.message || "Erro inesperado"}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="rounded bg-primary px-4 py-2 text-white hover:bg-primary/90"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundaryWrapper: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWrapper;
